import config from '../../../../share/config';
import apiService from '../../../../share/util/api/service';
import { executePolling } from '../../../../share/util/api/polling';
import { executeSyncRequest } from '../../../../share/util/api/syncRequest';
import eventLogUtil from '../../../../share/util/eventLogUtil';
import { SP_VCH } from '../../../../constants/usageCountTypes';

const VEHICLE_INIT = 'init';
const VEHICLE_INFO_GET = 'get';
const VEHICLE_MEMORY_CLEAR = 'clear';

/**
 * 初期化
 * @param {object} vm this インスタンス
 */
export async function initVch(vm) {
  try {
    vm.processing = true;
    await eventLogUtil.createEventLogHandleId(vm.netAppId);
    const response = await executePolling(
      vm,
      async () => {
        return await apiService.postCall(
          config.VCH,
          '/netApps/' + vm.netAppId + '/systems/' + vm.systemId + '/initialize',
          {
            use_cache: vm.isUseCache,
            is_special: true
          }
        );
      },
      async (postApiResponse) => {
        return await apiService.getCall(
          config.VCH,
          '/netApps/' + vm.netAppId + '/systems/' + vm.systemId + '/vehicleControlHistories/requests/' + postApiResponse.data.request_id
        );
      },
      (errorType) => { errorType; vm.showUnexpectedError(VEHICLE_INIT); },
      (postApiResponse) => {
        return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
      },
      undefined,
      (result) => { vm.validateErrorResult(result, VEHICLE_INIT); },
      (result) => { vm.validateErrorResult(result, VEHICLE_INIT); },
    );

    if (response) {
      await getBmc(vm);
    }
  } finally {
    vm.processing = false;
  }
}

/**
 * 制御作動履歴取得要求
 * @param {object} vm this インスタンス
 * @param {boolean} eventLogHandleIdFlg 操作イベントログを発行するかのフラグ
 */
export async function getBmc(vm, eventLogHandleIdFlg = false) {
  try {
    vm.processing = true;
    if (eventLogHandleIdFlg) {
      await eventLogUtil.createEventLogHandleId(vm.netAppId);
    }

    const response = await executePolling(
      vm,
      async () => {
        return await apiService.postCall(
          config.VCH,
          '/netApps/' + vm.netAppId + '/systems/' + vm.systemId + '/vehicleControlHistories',
          {
            is_special: true
          }
        );
      },
      async (postApiResponse) => {
        return await apiService.getCall(
          config.VCH,
          '/netApps/' + vm.netAppId + '/systems/' + vm.systemId + '/vehicleControlHistories/requests/' + postApiResponse.data.request_id
        );
      },
      (errorType) => { errorType; vm.showUnexpectedError(VEHICLE_INFO_GET); },
      (postApiResponse) => {
        return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
      },
      undefined,
      (result) => { vm.validateErrorResult(result, VEHICLE_INFO_GET); },
      (result) => { vm.validateErrorResult(result, VEHICLE_INFO_GET); },
    );

    if (response) {
      vm.measuredId = String(response.data.measured_id);
      vm.getVchListResponse = await getVchList(vm);
      if (!vm.getVchListResponse) {
        return;
      }
      vm.protocol = vm.getVchListResponse.data?.[0]?.protocol_type;
      vm.updateBmcTable();
      vm.usageCountUp({ type: SP_VCH, systemName: vm.systemId });
    }
  } finally {
    vm.processing = false;
  }
}

/**
 * 制御作動履歴一覧取得
 * @param {object} vm this インスタンス
 * @returns 制御作動履歴一覧
 */
export async function getVchList(vm) {
  try {
    vm.processing = true;
    const projectId = vm.vehicleInfo.vehicle.project.id;

    const response = await executeSyncRequest(
      vm,
      async () => {
        return await apiService.getCall(
          config.VCH,
          '/vehicleControlHistories/' + projectId + '/' + vm.measuredId,
          vm.operationScreen
        );
      },
      (errorType) => { errorType; vm.showUnexpectedError(VEHICLE_INFO_GET); },
      (getApiResponse) => {
        return getApiResponse && getApiResponse.data && getApiResponse.data.project ? '' : config.INDIVIDUAL_API_CALL_ERROR_GET_INVALID_RESPONSE;
      },
      (result) => { vm.validateErrorResult(result, VEHICLE_INFO_GET); },
    );
    return response ? response.data.project : null;
  } finally {
    vm.processing = false;
  }
}

/**
 * BMD取得
 * @param {object} vm this インスタンス
 * @param {string} bmc BMC
 * @param {string} systemId システムID
 * @returns BMD情報
 */
export async function getBmdResponse(vm, bmc, systemId) {
  try {
    vm.processing = true;
    const projectId = vm.vehicleInfo.vehicle.project.id;
    const response = await executeSyncRequest(
      vm,
      async () => {
        return await apiService.getCall(
          config.VCH,
          '/vehicleControlHistories/' + projectId + '/' + vm.measuredId + '/bmd/systems/' + systemId + '/codes/' + bmc,
          vm.operationScreen
        );
      },
      (errorType) => { errorType; vm.showUnexpectedError(VEHICLE_INFO_GET); },
      (getApiResponse) => {
        return getApiResponse && getApiResponse.data && getApiResponse.data.data ? '' : config.INDIVIDUAL_API_CALL_ERROR_GET_INVALID_RESPONSE;
      },
      (result) => { vm.validateErrorResult(result, VEHICLE_INFO_GET); },
    );
    return response ? response.data.data : null;
  } finally {
    vm.processing = false;
  }
}

/**
 * 制御作動履歴クリア要求
 * @param {object} vm this インスタンス
 */
export async function clearVchRequest(vm) {
  try {
    let protocol = '';
    vm.processing = true;
    let resultFlag = false;
    await eventLogUtil.createEventLogHandleId(vm.netAppId);
    const response = await executePolling(
      vm,
      async () => {
        return await apiService.postCall(
          config.VCH,
          `/netApps/${vm.netAppId}/systems/${vm.systemId}/vehicleControlHistories/clear`, {}
        );
      },
      async (postApiResponse) => {
        protocol = postApiResponse.data.protocol;
        return await apiService.getCall(
          config.VCH,
          '/netApps/' + vm.netAppId + '/systems/' + vm.systemId + '/vehicleControlHistories/requests/' + postApiResponse.data.request_id
        );
      },
      (errorType) => { errorType; vm.showUnexpectedError(VEHICLE_MEMORY_CLEAR); },
      (postApiResponse) => {
        return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
      },
      undefined,
      (result) => { vm.validateErrorResult(result, VEHICLE_MEMORY_CLEAR); },
      (result) => { vm.validateErrorResult(result, VEHICLE_MEMORY_CLEAR); },
    );

    if (response) {
      resultFlag = true;
    }
    vm.resultMemoryClear(resultFlag, protocol);
  } finally {
    vm.processing = false;
  }
}
